import React, { useEffect, useState } from 'react';

import { ActivityIndicator, Button, Checkbox, Toast, Modal } from 'antd-mobile';
import * as crypto from 'crypto-js';
import { ApiCore } from '../../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import currentBg from '../../static/images/login_bg.png';

import styles from './details.module.scss';

const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});

const mocktemplate = "<div><img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/channel/detail/doctor/d1.png' alt='' width='100%'/><img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/channel/detail/doctor/d2.png' alt='' width='100%'/><img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/channel/detail/doctor/d3.png' alt='' width='100%'/><img src='https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/channel/detail/doctor/d4.png' alt='' width='100%'/></div>"

function FindList(props: any) {

    const [appCode, setAppCode] = useState<any>('');
    const [userId, setUserId] = useState<any>('');
    const [template, setTemplate] = useState<any>('');
    const [url, setUrl] = useState<any>('');

    useEffect(() => {
        //设置网页title
        document.title = '发现';
        let appCode = sessionStorage.getItem('appCode')
        let localStorage_accountInf = localStorage.getItem('accountInf');
        if (localStorage_accountInf) {
            let accountInf = JSON.parse(localStorage_accountInf);
            setUserId(accountInf.account)
            let params = {
                appCode,
                userId: accountInf.account
            }
            api.GetConfigDetail(params).then(res => {
                if (res.code == '0') {
                    if (res.data.step2Type == 'ROUTE') {
                        setTemplate(res.data.step1Url)
                    }
                    setUrl(res.data.step2Url)
                }
            })
        }
        setAppCode(appCode)
        
    }, [])

    // 立即加入
    const JoinNow = () => {
        sessionStorage.removeItem('echoData')
        props.history.push(url)
    }

    return (
        <div className={styles.detailsContent}>
            <div className={styles.container} dangerouslySetInnerHTML={{ __html: template || mocktemplate }}></div>
            <div className={styles.jionBtnWrap}>
                <Button  type={'primary'} onClick={()=>JoinNow()}>立即加入</Button>
            </div>
        </div>
    )
}

export default FindList;
